/**
 * THE SHELL'S ISOLATED ARTIFACT WINDOW — owner, 2026-10-05: 「iOS / Mac App 需要如同使用
 * 自己的 App 一般, 可以直接使用 Avengents App 內建的 web browser 來打開」 a friend's shared
 * artifact; and, asked how, he chose the isolated window.
 *
 * WHY NOT THE VIEWER THE APP ALREADY HAS — where artifacts are served on the App's own
 * origin. There ArtifactViewer could frame a friend's page only AT that origin, and a
 * same-origin frame can reach `window.parent` — the App, its session and everything it can
 * do. For this account's own machine that is no escalation; for anyone else's page it is a
 * takeover (everywhere.ts `inAppViewGate`, docs/ARTIFACTS.md §3d). So there a friend's
 * artifact is shown by the NATIVE shell instead, in a separate web view whose cookie jar is
 * empty: it looks like the App's browser, it needs no second sign-in, and no account
 * session exists in there for the page to use.
 *
 * SINCE THE ARTIFACTS' OWN HOST, THIS IS THE SECOND CHOICE (owner, 2026-10-05: artifacts
 * move to a hostname of their own, and a friend's shared artifact then opens in the App's
 * main pane with the built-in viewer — SharedWithMe.tsx has the order). A cloud that has
 * made the move sends no `open_url`: its ticket lives on the other host. This function
 * would refuse such a ticket anyway, and that is deliberate, not an oversight to widen:
 * the shells that have this window accept a ticket on their own baked origin only and
 * drop anything else WITHOUT ANSWERING, while the row cancels its link as soon as the
 * message is posted — a wider check here would turn that tap into nothing at all.
 *
 * THE BRIDGE: `window.webkit.messageHandlers.avengentsArtifact.postMessage({url, title, by})`
 * — one WKScriptMessageHandler name answered by both shells, like `avengentsBadge`
 * (appBadge.ts). `url` is the row's `open_url`: a viewer ticket addressed to the relay's
 * `_avg/auth`, which is how a window without this session gets in (BFF
 * /account/artifacts/shared). The shell's side of the contract is docs/NATIVE.md §15.
 *
 * FEATURE-DETECTED. The handler does not exist in a browser, nor in the store builds on
 * real devices today (iOS ≤ 1.3, Mac ≤ 0.4) — there the row stays what it was, a link
 * that opens outside the App.
 */
type ArtifactBridge = { postMessage: (m: { url: string; title: string; by: string }) => void }

function artifactBridge(): ArtifactBridge | null {
  try {
    const w = window as unknown as {
      webkit?: { messageHandlers?: Record<string, ArtifactBridge | undefined> }
    }
    return w.webkit?.messageHandlers?.avengentsArtifact ?? null
  } catch {
    return null
  }
}

/**
 * Ask the shell to show a friend's artifact in its isolated window. True when a shell took
 * it — the caller then cancels the link's own navigation; false and the link goes on.
 *
 * ONLY A TICKET ADDRESSED TO AN ARTIFACT'S OWN `_avg/auth` IS EVER HANDED OVER. The shell
 * checks the same thing on its side; checking here too means a row built from a malformed
 * answer falls back to the plain link instead of asking the shell to open something else.
 */
export function openInArtifactWindow(a: { openUrl: string | null | undefined; title: string; by: string }): boolean {
  const bridge = artifactBridge()
  if (!bridge || !a.openUrl) return false
  try {
    const u = new URL(a.openUrl, window.location.origin)
    if (u.origin !== window.location.origin) return false
    if (!/\/artifacts\/[a-f0-9]{24}\/_avg\/auth$/.test(u.pathname) || !u.searchParams.get('vt')) return false
    bridge.postMessage({ url: u.toString(), title: a.title.slice(0, 200), by: a.by.slice(0, 200) })
    return true
  } catch {
    return false
  }
}
